import { PencilSimple, TrashSimple } from "@magnetic/icons";
import { Tooltip } from "@magnetic/tooltip";

import { Button } from "src/components/buttons";
import { HFlex } from "src/components/hFlex";

import { BaseColumnConfig, Config } from "./baseColumnConfig";

export type BotActionProps = {
  handleCallback: () => void;
  disabled?: boolean;
  tooltip?: string;
};

export type BotEditDeleteActions = {
  edit?: BotActionProps;
  delete?: BotActionProps;
};

/**
 * Actions column for bot management tables
 * Handles edit and delete actions with optional tooltips and disabled states
 */
export class BotActionsColumn extends BaseColumnConfig<BotEditDeleteActions> {
  constructor(config: Config) {
    config.rowIdentifier ??= false; // The action buttons are not a good contender for key participation
    config.pinned ??= "right"; // UX standard, actions are pinned on the right
    super(config);
  }

  identity() {
    return undefined;
  }

  compare(): number {
    return 0;
  }

  render(actions: BotEditDeleteActions) {
    const { edit, delete: deleteAction } = actions;

    const deleteButton = deleteAction && (
      <Button
        name="delete-bot"
        icon={<TrashSimple size={16} weight="bold" />}
        kind="tertiary"
        onClick={deleteAction.handleCallback}
        disabled={deleteAction.disabled}
        data-qa="delete-bot-button"
      />
    );

    return (
      <HFlex gap="none">
        {edit && (
          <Button
            name="edit-bot"
            icon={<PencilSimple size={16} weight="bold" />}
            kind="tertiary"
            onClick={edit.handleCallback}
            disabled={edit.disabled}
            data-qa="edit-bot-button"
          />
        )}
        {deleteAction?.tooltip ? (
          <Tooltip title={deleteAction.tooltip} placement="top">
            {deleteButton}
          </Tooltip>
        ) : (
          deleteButton
        )}
      </HFlex>
    );
  }
}
